module.exports = __webpack_public_path__ + "static/img/bonus_1.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_1.png
// module id = A2Iv
// module chunks = 0